/* eslint-disable @typescript-eslint/no-explicit-any */
import { Tuple } from "../globalTypes";
import {
  BugModalInvoker,
  ErrorData,
  ErrorEntity,
} from "../store/bugReport/types";

const environment = process.env.NODE_ENV;
export const isProductionEnv = environment === "production";
export const isDevEnv = environment === "development";
export const isTestEnv = environment === "test";

export function timeout(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export const isNumber = (candidate: any): boolean =>
  !Number.isNaN(Number(candidate));

const reverseRange = (x: number, y: number): [number, number] => [y, x];

export const isNumberInRange = (
  range: Tuple<number | null>,
  number: number
): boolean => {
  let [from, to] = range;
  // mozna by to chtelo pridat spis jako kontrolu pri vytvareni podminky, ze nesmi byt od vetsi nez do
  if (from && to && Number(from) > Number(to)) {
    [from, to] = reverseRange(from, to);
  }
  if (from === null && to === null) return true;
  if (from === null) return number <= Number(to);
  if (to === null) return from <= number;
  return from <= number && number <= to;
};

// Hodnoty parametru v catch clause je třeba takhle nakopčit, dokud existujou
// Afaik to nejde rozumně otypovat
export const makeErrorData = <T extends ErrorData = ErrorData>(error: any): T =>
  ({
    message: error?.message,
    name: error?.name,
    stack: error?.stack,
    componentStack: error?.componentStack,
  } as T);

export const makeErrorEntity = (
  invoker: BugModalInvoker,
  errorData: ErrorData | ErrorData[],
  errorTime?: string
): ErrorEntity => {
  const now = new Date().toISOString();
  return {
    errorData,
    handledBy: invoker,
    timeOfError: errorTime || now,
    bugReported: false,
  };
};

export const sortObjectKeys = <Obj extends Record<number | string, unknown>>(
  obj: Obj
): Obj => {
  const sortedKeys = Object.keys(obj).sort() as (keyof Obj)[];

  return sortedKeys.reduce((acc, key) => {
    acc[key] = obj[key];
    return acc;
  }, {} as Obj);
};

export const isOneOf = (value: any, array: any[] | readonly any[]): boolean =>
  array.includes(value);
